/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';

export default (props: { isLoading: boolean }): null | Element<string> =>
  props.isLoading ? (
    <div
      className="alert alert-info"
      style={{ paddingBottom: 10, margin: '10px 0' }}
    >
      Loading...
    </div>
  ) : null;
